import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';
import { Platform } from 'react-native';
import browser from 'detect-browser';

import img_logoRed from '../img/logo_red.png';

export default class Header extends Component {
  style = {};
  render = () => (
    <AppBar
      style={{ backgroundColor: 'white' }}
      className="header"
      onLeftIconButtonTouchTap={this.props.handleToggleDrawer}
      title={
        <img
          src={img_logoRed}
          alt={img_logoRed}
          height="32px"
          style={{
            float: 'right',
            padding:
              browser.name === 'fxios' || (browser.name === 'fx' && Platform.OS === 'iosweb') ? '9px 36px 9px 0px' : '9px 0px 9px 0px',
          }}
        />
      }
    />
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/